var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.condition)?_c('div',[_c('v-card',{staticClass:"text-center"},[_c('v-card-text',[_vm._v(_vm._s(_vm.$t("string.noItem")))])],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }